<template>
  <div ref="root" id="footer" class="footer">
    <div class="top-grid">
      <section class="top-items top-content-primary">
        <div class="footer-top">
          <div>
            <router-link to="/"><img class="top-inner-img fade-right-out" src="~@/assets/img/logo/logo_simple.png" />
              <span class="footer-title">CYCLONE GYM</span>
            </router-link>
            <div class="footer-adress">東京都葛飾区金町6-4-4 クライスビル1F</div>
          </div>

          <ul class="footer__list sp-none">
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#concept' : '/#concept'"> コンセプト </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#news' : '/#news'"> お知らせ </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#lesson' : '/#lesson'"> スケジュール </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#menu' : '/#menu'"> クラス紹介 </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#price' : '/#price'"> 料金 </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#flow' : '/#flow'"> 入会の流れ </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#qa' : '/#qa'"> よくある質問 </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#staff' : '/#staff'"> スタッフ紹介</router-link>
            </li>
            <li class="footer__item"><router-link to="/Facilittes">施設紹介</router-link></li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#info' : '/#info'"> ジム案内</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="$route.path === '/ ' ? '#access' : '/#access'"> アクセス</router-link>
            </li>
            <li class="footer__item">
              <router-link to="/Contact"> お問い合わせ </router-link>
            </li>
          </ul>
        </div>

        <div class="footer-copy">Copyright © 2023 CYCLOME GYM All rights reserved.</div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed, ComputedRef } from 'vue'
import { useApplicationStore } from '@/store/modules/applicationModule'

interface State {
  active: any
}

export default defineComponent({
  components: {},
  setup() {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const child = ref(null)
    const state = reactive<State>({
      active: false,
    })

    return {
      root,
      child,
      state,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

.footer {
  padding-top: 20px;
  background-color: #333;
  font-family: 'Shippori Mincho', serif;
  color: #fff;

  a {
    font-family: 'Shippori Mincho', serif;
    color: #fff;
    display: flex;
    align-items: center;

    img {
      max-width: 100px;
      margin-bottom: 10px;
    }
  }

  section {
    max-width: 1200px;
    margin: 0 auto;
    width: 95%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #fff;
    padding-bottom: 40px;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    max-width: 500px;
    width: 95%;

    & li {
      margin-right: 20px;
      margin-bottom: 5px;
      a {
        font-size: 1.4rem;
      }
    }
  }

  &-title {
    font-size: 1.6rem;
    margin-left: 10px;
    letter-spacing: 0.05em;
  }

  &-copy {
    font-size: 1.4rem;
    text-align: right;
    padding-top: 10px;
    letter-spacing: 0.05em;
    margin-bottom: 40px;
  }

  &-adress {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 768px) {
  .footer-top {
    flex-direction: column;
  }

  .footer__list {
    justify-content: center;
    margin-top: 40px;
  }

  .footer-copy {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 360px) {
  .footer-copy {
    font-size: 1rem;
  }
}
</style>
